import { h, Fragment } from 'preact';
import * as is from 'utilities/is';
import { now } from 'utilities/time';
import { makeUniqueId } from 'utilities/data';
import { Loader } from 'rendering/components/loader';

const NO_ANSWER = null;

export const formatResponse = ({
    formData = {},
    quizConfig = {},
    quizState = {},
    questions = []
}) => {
    let usedRetries = 0;
    const {
        currentScore,
        passing,
        answeredCorrectly = [],
        startTime,
        remainingRetries
    } = quizState;
    const { id, properties = {} } = quizConfig;
    const { evaluateQuiz = true } = properties;
    const totalTimeSeconds = (now() - startTime) / 1000;
    const formattedQuestions = (
        questions
            .map(q => {
                const { id, content: text, properties = {} } = q;
                const { points = NO_ANSWER } = properties;
                const answers = describeAnswers(q, formData[q.id]);
                const correct = evaluateQuiz ? answeredCorrectly.includes(id) : NO_ANSWER;

                return {
                    id,
                    text,
                    correct,
                    points,
                    answers
                }
            })
    );

    if (is.defined(properties.allowedRetries)) {
        usedRetries = properties.allowedRetries - remainingRetries;
    }
    
    return {
        passing,
        quizId: id,
        usedRetries,
        totalTimeSeconds,
        score: currentScore,
        submitId: makeUniqueId(false),
        questions: formattedQuestions,
        submittedTime: Date.now()
    }
};

const describeAnswers = (question = {}, answers = '') => {
    const availableAnswers = question.descendants?.filter(d => d.type === 'answer') || [];
    const answersByValue = availableAnswers.reduce((byValue, a) => {
        const { value } = a.properties || {};
        if (value) {
            byValue[value] = a;
        }
        return byValue;
    }, {});

    return (
        [].concat(answers) // answers may be single value or array
            .filter(a => a !== '')
            .map(value => {
                const answer = answersByValue[value] || {};
                const description = {                    
                    id: answer.id || NO_ANSWER,
                    label: answer.content || NO_ANSWER,
                    correct: NO_ANSWER,
                    value
                };

                if (is.defined(answer.properties?.correct)) {
                    description.correct = answer.properties.correct;
                }

                return description;
            })
    )
}

export const RECORDING_STATUSES = {
    NOT_APPLICABLE: 'notapplicable',
    NOT_STARTED: 'notstarted',
    IN_PROGRESS: 'inprogress',
    SUCCESSFUL: 'successful',
    FAILED: 'failed'
}

export const RecordingStatus = ({status = RECORDING_STATUSES.NOT_STARTED, color}) => {
    let statusText = null;
    
    switch(status) {
        case RECORDING_STATUSES.IN_PROGRESS:
            statusText = 'Saving Responses';
            break;
        
        case RECORDING_STATUSES.SUCCESSFUL:
            statusText = 'Response Saved';
            break;

        case RECORDING_STATUSES.FAILED:
            statusText = 'Save Failed!';
            break;
    }

    return (
        <div role="status" style={{color}} className="quiz-record-status" data-status={status}>            
            {statusText}
            <Loader />
        </div>
    )
}